import { render, staticRenderFns } from "./LabTemplate.vue?vue&type=template&id=73a21274&scoped=true"
import script from "./LabTemplate.vue?vue&type=script&lang=js"
export * from "./LabTemplate.vue?vue&type=script&lang=js"
import style0 from "./LabTemplate.vue?vue&type=style&index=0&id=73a21274&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a21274",
  null
  
)

export default component.exports